export const typography = {
  fontFamily: 'Outfit, sans-serif',
  fontWeightSemiBold: 600,
  body1: {
    fontSize: '1rem'
  }
};
